module.exports = __webpack_public_path__ + "img/voipms-logo.1cd59ba8.png";